import gql from 'graphql-tag';

export const UpdateParticipantRestrictivePractice = gql`
  mutation UpdateParticipantRestrictivePractice(
    $organizationId: ID!
    $participantId: ID!
    $restrictivePracticeId: ID!
    $request: UpdateParticipantRestrictivePracticeRequest!
  ) {
    updateParticipantRestrictivePractice(
      organizationId: $organizationId
      participantId: $participantId
      restrictivePracticeId: $restrictivePracticeId
      request: $request
    ) {
      id
    }
  }
`;
